import React from "react";

interface NavigationCardProps {
  children: React.ReactNode;
  setIsMenuOpen: (isMenuOpen: boolean) => void;
  icon?: string;
  iconComponent?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export function SettingsCard({
  children,
  setIsMenuOpen,
  icon,
  iconComponent,
  className,
  onClick,
}: NavigationCardProps) {
  return (
    <div
      className={`flex flex-row items-center justify-center w-full min-h-20 bg-White border-b-2 border-Grey4`}
      onClick={onClick}
    >
      <div className="w-[10%]">
        {iconComponent
          ? iconComponent
          : icon && (
              <i
                className={`fa-solid fa-${icon}`}
                style={{
                  textAlign: "center",
                  marginBottom: 12,
                }}
              />
            )}
      </div>

      <div className="w-[90%]">{children}</div>
    </div>
  );
}
